"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadersService = exports.headersService = void 0;
var tslib_1 = require("tslib");
var device_description_1 = require("../../device-description");
var device_name_factory_1 = require("../../device-description/device-name-factory");
var window_service_1 = require("../window-service");
var client_description_serializer_1 = require("./client-description-serializer");
var models_1 = require("./models");
var buildClientDescription = function () {
    var navigator = window_service_1.windowService.detectNavigator();
    var system = device_description_1.systemFactory.create(navigator);
    var deviceType = device_description_1.deviceTypeFactory.create(navigator);
    var deviceName = device_name_factory_1.deviceNameFactory.create(navigator);
    return client_description_serializer_1.clientDescriptionSerializer.toHeaderValue({
        deviceName: deviceName,
        deviceType: deviceType,
        system: system,
    });
};
var defaultHeaders = {
    "Client-Description": buildClientDescription(),
    "Content-Type": "application/json",
    "Api-Version": models_1.AuthSuiteAPIVersion.WITH_VALIDATION_ERROR_MESSAGES,
};
var getHeadersWithAuthorization = function (applicationAccessToken, headers) {
    headers.Authorization = "Bearer ".concat(applicationAccessToken);
    return headers;
};
var getHeaders = function (customRequestHeaders, applicationAccessToken) {
    var headers = tslib_1.__assign(tslib_1.__assign({}, defaultHeaders), customRequestHeaders);
    return applicationAccessToken ? getHeadersWithAuthorization(applicationAccessToken, headers) : headers;
};
exports.headersService = {
    getHeaders: getHeaders,
};
var HeadersService = /** @class */ (function () {
    function HeadersService() {
        return exports.headersService;
    }
    return HeadersService;
}());
exports.HeadersService = HeadersService;
